module.exports = "/static/assets/0811cf7fc2cb22f4e54d6cb59101ec0a.png";